import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllAcademicTerms as apiDeleteAll } from "../../api/apiAcademicTerms";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllAcademicTerms() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAllAcademicTerms, isPending: isDelete } = useMutation({
        mutationFn: (req) => apiDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicTerms"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAllAcademicTerms, isDelete };
}
